import "core-js/modules/es.array.push.js";
const __default__ = {
  name: "StaffsEdit"
};
import useSWRV from "swrv";
import emailValidator from "email-validator";
import { createData, getData, updateData, deleteData } from "@/services/axios";

import { useRoute, useRouter } from 'vue-router/composables';
import { inject, watch, ref } from 'vue';
import { isAuthenticatedKey, meKey } from '/codebuild/output/src2081543335/src/cocoo_gov/src/utils/injectionKey.js';
import { useConfirmDialog } from '@vueuse/core';
export default /*#__PURE__*/Object.assign(__default__, {
  setup(__props) {
    // @ts-check
    const route = useRoute();
    const router = useRouter();
    const isAuthenticated = inject(isAuthenticatedKey);
    const me = inject(meKey);
    watch([me, isAuthenticated], () => {
      // 管理者以外の場合は Dashboard に戻す
      if (isAuthenticated.value && !me.value?.allow?.admin) {
        router.push({
          name: "Dashboard"
        });
      }
    }, {
      immediate: true
    });
    const isCreate = ref(!route.params.id);
    const isLoading = ref({
      postData: false
    });
    const {
      data: staffBaseData,
      isValidating
    } = useSWRV(() => me.value?.allow?.admin && !isCreate.value && `staffs/${route.params.id}`, async () => {
      const result = await getData(`staffs/${route.params.id}`, {
        with: "user"
      });
      return result.items;
    }, {
      revalidateOnFocus: false,
      ttl: 2000
    });

    /** @returns {{ id: number; name: string; department: string; email: string; admin: boolean; forum_post: boolean; role_id: number }} */
    const setEditStaffData = () => {
      return {
        id: staffBaseData.value?.id ?? "",
        name: staffBaseData.value?.name ?? "",
        department: staffBaseData.value?.department ?? "",
        email: staffBaseData.value?.email ?? "",
        admin: staffBaseData.value?.allow?.admin ?? false,
        forum_post: staffBaseData.value?.allow?.forum_post ?? false,
        role_id: 9
      };
    };
    const staff = ref(setEditStaffData());
    watch(staffBaseData, () => {
      staff.value = setEditStaffData();
    });
    const resetError = () => {
      return {
        name: "",
        department: "",
        email: ""
      };
    };
    const error = ref(resetError());
    const validateInput = () => {
      let valid = true;
      error.value = resetError();
      if (!staff.value.name) {
        error.value.name = "名前を入力してください。";
        valid = false;
      }
      if (!staff.value.department) {
        error.value.department = "所属を入力してください";
        valid = false;
      }
      if (!staff.value.email) {
        error.value.email = "メールアドレスを入力してください。";
        valid = false;
      } else if (!emailValidator.validate(staff.value.email)) {
        error.value.email = "メールアドレスの形式が正しくありません。";
        valid = false;
      }
      return valid;
    };
    const loadingMessage = ref("");
    const messageSettings = ref({
      title: "",
      message: ""
    });
    const {
      isRevealed: isModalRevealed,
      ...modalDialog
    } = useConfirmDialog();
    const saveData = async () => {
      if (!validateInput()) {
        return;
      }
      staff.value.name = staff.value.name.replace(/\s+/, " ");
      isLoading.value.postData = true;
      try {
        if (isCreate.value) {
          loadingMessage.value = "職員情報を登録しています。";
          await createData("staffs", staff.value);
          messageSettings.value = {
            message: "職員情報登録が完了しました",
            title: "登録完了"
          };
        } else {
          loadingMessage.value = "職員情報を更新しています。";
          await updateData("staffs/" + route.params.id, staff.value);
          messageSettings.value = {
            message: "職員情報更新が完了しました",
            title: "更新完了"
          };
        }
        await modalDialog.reveal();
      } catch (e) {
        messageSettings.value = {
          message: "職員情報登録に失敗しました。既存の職員とメールアドレスが重複している可能性があります。",
          title: "エラー"
        };
        modalDialog.reveal();
        console.log(e);
      } finally {
        isLoading.value.postData = false;
      }
    };
    modalDialog.onConfirm(() => router.push({
      name: "Staffs"
    }));
    const {
      isRevealed: isConfirmModalRevealed,
      ...confirmModalDialog
    } = useConfirmDialog();
    confirmModalDialog.onConfirm(async () => {
      try {
        const result = await deleteData("staffs/" + route.params.id);
        if (result.error_code) {
          switch (result.error_code) {
            case 404:
              messageSettings.value = {
                message: "職員の更新に失敗しました (Auth0 user not found)",
                title: "エラー"
              };
              break;
            default:
              messageSettings.value = {
                message: "職員の更新に失敗しました (" + result.errors + ")",
                title: "エラー"
              };
              break;
          }
        } else {
          messageSettings.value = {
            message: "職員データを削除しました",
            title: "削除完了"
          };
        }
      } catch (e) {
        messageSettings.value = {
          message: "職員データの削除に失敗しました",
          title: "エラー"
        };
        console.log(e);
      } finally {
        modalDialog.reveal();
      }
    });
    return {
      __sfc: true,
      route,
      router,
      isAuthenticated,
      me,
      isCreate,
      isLoading,
      staffBaseData,
      isValidating,
      setEditStaffData,
      staff,
      resetError,
      error,
      validateInput,
      loadingMessage,
      messageSettings,
      isModalRevealed,
      modalDialog,
      saveData,
      isConfirmModalRevealed,
      confirmModalDialog
    };
  }
});